/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { Button as p } from "@progress/kendo-react-buttons";
import { useLocalization as g } from "@progress/kendo-react-intl";
import { onDownPreventDefault as f } from "./utils.mjs";
import { messages as u } from "../messages/index.mjs";
import { cleanFormatting as b } from "@progress/kendo-editor-common";
import { EditorToolsSettings as N } from "../config/toolsSettings.mjs";
import { classNames as v } from "@progress/kendo-react-common";
const { cleanFormatting: k } = N, c = b(), S = (a) => {
  const { view: t, render: s, settings: o = k, ...l } = a, n = o.messages.title, e = !t || !c(t.state), d = r.useCallback(
    () => {
      t && c(t.state, (i) => {
        i.setMeta("commandName", o.commandName), t.dispatch(i);
      });
    },
    [t]
  ), m = /* @__PURE__ */ r.createElement(
    p,
    {
      onClick: e ? void 0 : d,
      "aria-disabled": e ? !0 : void 0,
      title: g().toLanguageString(n, u[n]),
      ...f,
      ...o.props,
      ...l,
      className: v(a.className, o.props.className, { "k-disabled": e })
    }
  );
  return s ? s.call(void 0, m, { view: t }) : m;
};
export {
  S as CleanFormatting
};
